export default __webpack_public_path__ + "images/d21e572779ffd0af1cf47530700cd244-link.svg";